import { AlertColor, Box, Typography } from '@mui/material';
import { FC, useState } from 'react';

import PolicyAlert from '@acorn-portal/shared/src/components/alerts/Alert';

import parser from 'html-react-parser';

interface InfoAlertProps {
	infoText: string;
	title: string;
}

const InfoAlerts: FC<InfoAlertProps> = ({ infoText, title }) => {
	const [showAlert, setShowAlert] = useState(true);
	const alertType: AlertColor = 'info';

	const handleCloseAlert = () => setShowAlert(false);

	return (
		<>
			{showAlert && (
				<Box sx={{ marginBottom: 2 }}>
					<PolicyAlert type={alertType} hideBorder title={title} onCloseAction={handleCloseAlert}>
						<Typography>{parser(infoText)}</Typography>
					</PolicyAlert>
				</Box>
			)}
		</>
	);
};

export default InfoAlerts;
